import MUIDivider from '@mui/material/Divider';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
}

/**
 * Компонент для отображения горизонтальной линии-разделителя.
 *
 * @returns  JSX-элемент, представляющий разделитель.
 */
export const Divider = ({ orientation }: DividerProps) => {
  return (
    <MUIDivider
      className="aqa_divider"
      data-testid="divider-testid"
      orientation={orientation}
      flexItem={orientation === 'vertical'}
    />
  );
};
